import ScrollReveal from 'scrollreveal';

const options = {
  easing: 'cubic-bezier(.250, .100, .250, 1)',
  distance: '75px',
  duration: 1000,
  interval: 200,
  origin: 'bottom',
  viewFactor: 0,
};

if (window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
  const selectors = ['.js-scrollreveal'];

  for (const selector of selectors) {
    ScrollReveal().reveal(selector, options);
  }
}
